import { Text } from '@thanx/uikit/text'
import { Role, rolesApi } from 'api/roles'
import Modal from 'components/ModalContainer'
import { useDisplayMessage } from 'hooks/useDisplayMessage'
import { buildTranslate } from 'locales'

type Props = {
  visible: boolean
  setIsVisible: (visible: boolean) => void
  role?: Role
}

const t = buildTranslate('dashboard_access.delete_modal')

export const DeleteRoleModal = ({ visible, setIsVisible, role }: Props) => {
  const [deleteRole] = rolesApi.useDeleteRoleMutation()
  const displayMessage = useDisplayMessage()

  if (!role) return null

  const hasUsers = (role.users_count ?? 0) > 0

  const handleDelete = async () => {
    try {
      await deleteRole(role.id).unwrap()
      setIsVisible(false)
    } catch {
      displayMessage(t('delete_error'), 'danger')
    }
  }

  return (
    <Modal
      isOpen={visible}
      onClose={() => setIsVisible(false)}
      proceedText={t('delete')}
      canProceed={!hasUsers}
      onProceed={handleDelete}
    >
      <h3 className="mt-0 mb-xs extra-bold">{t('title')}</h3>
      <div className="mt-xl">
        <Text.BodyText2 className="mb-xs">
          {hasUsers
            ? t('has_users', { count: role.users_count })
            : t('description', { roleName: role.display_name })}
        </Text.BodyText2>
      </div>
    </Modal>
  )
}
